export default {

    getNextSlide: state => id => {
        let getNext = false;
        const nextSlide = state.hero.originalSlides.find(slide => {
            if (getNext) {
            return true;
            }
            getNext = slide.id === id;
            return false;
        });
        if (!nextSlide) {
            return state.hero.originalSlides.find(({url}) => url);
        }
        return nextSlide;
    },

    // getCommentById(state, id) {
    //     let commentById = state.comments.filter(comment => comment.id === state.comment.id);
    //     console.log(commentById);
    //     return commentById;
    // }


}